import React from 'react';
import timerSvg from 'images/timer.svg';
import { useTranslation } from 'react-i18next';

const TimerText = () => {
    const { t } = useTranslation();

    return (
        <div className='fl-survey-cover-block-text'>
            <div>
                <img src={ timerSvg } alt='timer' />
            </div>
            <div className='fl-survey-wc-time-rule'>
                { t('welcome.we_recommend_taking_the_assessment') }
            </div>
        </div>
    );
};

export default TimerText;
